const MyPlugin = {
  install(Vue, options) {
    Vue.prototype.$confirm = function() {
      return window.confirm('Do you really want to submit?')
    }

    Vue.prototype.$onDataSuccess = function(response) {
      // if (typeof this.apiData.status_text !== 'undefined') {
      //   $('#searchResult').removeClass('hide')
      // } else {
      //   alert('Data not found')
      // }
      window.location = '/#/sukses/' + response
    }

    Vue.prototype.$onDataError = function(e) {
      if (e.status === 403 || e.status === 500 || e.status === 400) {
        console.log(e);
        alert(JSON.parse(e.errortext).error)
      } else if (e.status === 401) {
        // this.$router.push('/logout')1
        window.location = '/#/logout'
      }
    }
  },
}

export default MyPlugin



// WEBPACK FOOTER //
// ./src/plugins/confirm.js